module.exports = __webpack_public_path__ + "static/straw-pellets-bags-5bcece67697a497a65b2b965bb29a3d5.jpg";